import { STATUS_STYLES, SEVERITY_STYLES, CATEGORY_STYLES, prettyStatus } from "@/lib/format";
import { cn } from "@/lib/utils";

export const StatusBadge = ({ status, kind = "status", className, ...props }) => {
  const map = kind === "severity" ? SEVERITY_STYLES : kind === "category" ? CATEGORY_STYLES : STATUS_STYLES;
  const style = map[status] || "bg-slate-100 text-slate-700 border-slate-200";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize whitespace-nowrap",
        style,
        className
      )}
      {...props}
    >
      {prettyStatus(status)}
    </span>
  );
};
